import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setActiveNavbarTab } from "../../../redux-store/slice/activeNavbarSlice";
import Navbar from "../navbar/Navbar";
import PHRAppHeader from "../phr-app-header/PHRAppHeader";
import FeatureSettings from "../feature-settings/FeatureSettings";

const FeatureSettingsPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveNavbarTab("feature_settings"));
  }, [dispatch]);

  return (
    <div className="w-full h-screen relative">
      <div className="z-40 relative">
        <PHRAppHeader />
      </div>
      <div className="flex w-full relative pt-14">
        <div className="w-fit fixed z-50 h-screen shadow">
          <Navbar />
        </div>
        <div className="w-[94.8%] ml-auto">
          <FeatureSettings />
        </div>
      </div>
    </div>
  );
};

export default FeatureSettingsPage;
